<template>
    <div id="viewermove" v-if="initEpisodeState !== null">
        <div class="viewermove_box">
            <div class="prev" @click="prevEpisode" :class="[initPreEpisodeIdx !== null ? 'click' : '']">
                <img src="../assets/images/mobile/next_arrow.svg" alt="이전화">
                <p>이전화</p>
            </div>
            <div class="next" @click="nextEpisode" :class="[initNextEpisodeIdx !== null ? 'click' : '']">
                <p>다음화</p>
                <img src="../assets/images/mobile/next_arrow.svg" alt="다음화">
            </div>
        </div>
        <Login :initIsShowPopup="isShowLoginPopup" @close="close('Login')" />
    </div>
</template>

<script>

import Login from '@/components/Login.vue'

export default {
    name: 'Viewermove',
    components: {
        Login,
    },
    data(){
        return {
            chagneEpisodeInfo: null,
            isShowLoginPopup: false,
        }
    },
    props: {
        initWebtoonInfo: {
            type: Object,
            default: null
        },
        initEpisodeState: {
            type: Object,
            default: null
        },
        initPreEpisodeIdx: {
            type: Object,
            default: null
        },
        initNextEpisodeIdx: {
            type: Object,
            default: null
        },
    },
    created() {
        this.mixinSiteConfigCheck();
    },
    mounted(){
    },
    beforeDestroy() {
	},
    methods: {
        async prevEpisode(){
            if(this.initPreEpisodeIdx !== null){
                this.checkEpisodeState(this.initWebtoonInfo.ctWebtoonIdx, this.initPreEpisodeIdx.idx);
            }
        },
        async nextEpisode(){
            if(this.initNextEpisodeIdx !== null){
                this.checkEpisodeState(this.initWebtoonInfo.ctWebtoonIdx, this.initNextEpisodeIdx.idx)
            }
        },
        async checkEpisodeState(wtIdx, epIdx){
            var param = 
            {
                ticket: this.$store.state.ticket,
                sign: this.$store.state.sign,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0,

                webtoonIdx: wtIdx,
                episodeIdx: epIdx,
                // lang: 'KR'
            }
            // console.log(param);
            await this.$Axios.post(`${this.league_host}/challenge/episode/state`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                // console.log('----episode state----');
                // console.log(res);

                if(res.data.epData != null){
                    this.chagneEpisodeInfo = res.data.epData;
                }

                if (res.data.returnCode === 0) {
                    this.$router.push('/LeagueViewer/' + wtIdx + '/' + epIdx);
                }
                else if(res.data.returnCode === 503){   //로그인 필요
                    this.isShowLoginPopup = true;
                }
                else{
                    console.log(res.data.dsscription);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        close(popupType){
            switch(popupType){
                case 'Login':
                    this.isShowLoginPopup = false;
                    break;
            }
        },
    },
}
</script>